import React, { useState, useEffect } from "react";

const Countdown = ({ initialMilliseconds }) => {
  const [milliseconds, setMilliseconds] = useState(initialMilliseconds);

  useEffect(() => {
    if (milliseconds > 0) {
      const intervalId = setInterval(() => {
        setMilliseconds((prevMilliseconds) => prevMilliseconds - 10);
      }, 10); // Atualiza a cada 10 milissegundos para dar mais precisão

      return () => clearInterval(intervalId); // Limpa o intervalo quando o componente desmonta ou o tempo acaba
    }
  }, [milliseconds]);

  const seconds = Math.floor(milliseconds / 1000);
  const ms = milliseconds % 1000;

  return (
    <div>
      <p>
      {seconds} segundos
      </p>
    </div>
  );
};

export default Countdown;

